import { useRelationshipsContext } from '../providers/RelationshipsProvider';

/**
 * This hook allows getting/updating reference picker data.
 * It must be used inside `RelationshipsProvider` component.
 *
 * addRelationships - callback to add new relationship. Expects one argument - an array of new relationships to add.
 *
 * @returns {{addRelationships: function}}
 */
export default () => {
  const { addRelationships } = useRelationshipsContext();
  return {
    addRelationships,
  };
};
